import firebase from 'firebase/compat'
import {collection, getDocs, query} from 'firebase/firestore'
import {
    createUserWithEmailAndPassword,
    getAuth,
    sendPasswordResetEmail,
    signInAnonymously,
    signInWithEmailAndPassword,
    signOut,
    updateProfile
} from 'firebase/auth'
import { getAnalytics } from "firebase/analytics";
import {getDownloadURL, getStorage, ref} from "firebase/storage";
import router from "@/plugins/router";

const FirebaseConfig = {
        apiKey: "AIzaSyDY7XCOI9aodCo0GCdazqX42TGGzrshDrM",
        authDomain: "aaden-saas.firebaseapp.com",
        projectId: "aaden-saas",
        storageBucket: "aaden-saas.appspot.com",
        messagingSenderId: "169167876904",
        appId: "1:169167876904:web:c4c32904c2887223cc161d",
        measurementId: "G-2C8KD1KSKR"
}
const websiteUrl = 'websiteUrls'

export const app = firebase.initializeApp(FirebaseConfig)
export const analytics = getAnalytics(app);
export const db = firebase.firestore(app)
export const FireBaseAuth = getAuth(app)
const storage = getStorage(app)


export async function getUrlForFile(fileUrl) {
    return await getDownloadURL(ref(storage, fileUrl))
}

export async function checkNewRecords() {
    const collectionRef = collection(db, websiteUrl)
    const res = query(collectionRef)
    return (await getDocs(res)).docs.map(it => it.data())
}

export async function loginWithPassword(email, password) {

    try {
        await signInWithEmailAndPassword(FireBaseAuth, email, password)
        return {result: true, message: ''}
    } catch (e) {
        console.log(e.message)
        return {result: false, message: e.message}
    }
}

export async function logout() {
    await signOut(FireBaseAuth)
}

export async function createUserWithPassword(email, password) {
    try {
        await createUserWithEmailAndPassword(FireBaseAuth, email, password)
        return {result: true, message: ''}
    } catch (e) {
        return {result: false, message: e.message}
    }
}

export async function loginAsGuest() {
    await signInAnonymously(FireBaseAuth)
}

export async function resetPassword(email) {
    await sendPasswordResetEmail(FireBaseAuth, email)
}

export async function login() {
    await router.push('/home')
}

export async function updateUserProfile(userName) {
    await updateProfile(FireBaseAuth.currentUser,
        {displayName: userName, photoURL: ''})
}

export function currentUserId() {
    return FireBaseAuth.currentUser.uid
}

FireBaseAuth.useDeviceLanguage()

FireBaseAuth.onAuthStateChanged(user => {
    if (user) {
        login()
    } else {
        router.push('/')
    }
})


